import { Box } from "@mui/material";
import { useState } from "react";
import AsyncSelect from "../../../../../components/AsyncSelect";
import Flex from "../../../../../components/Flex";
import LabeledSwitch from "../../../../../components/LabeledSwitch";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";
import useDebouncedCallback from "../../../../../hooks/use-debounced-callback";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import {
  CONTACT_TYPE_OPTIONS,
  ContactDictionaryFilter,
} from "../contact-dictionary/contact-dictionary-constant";
import SearchInput from "../../../../../components/SearchInput";

export interface SmsTextFilterState {
  messageType: string;
  searchQuery: string;
}

export interface ChatFilterState {
  chatStatus: string;
  searchQuery: string;
}

export interface EmailFilterState {
  emailType: string;
  searchQuery: string;
}

export interface FaxFilterState {
  faxStatus: string;
  searchQuery: string;
}

// Filter components with direct useDebounce usage
export const SmsTextFilters = ({
  filters: _f,
  onFilterChange: _onFilterChange,
  onSearch: _onSearch,
}: {
  filters: SmsTextFilterState;
  onFilterChange: (key: string, value: string) => void;
  onSearch: (query: string) => void;
}) => {
  // const [_searchValue, setSearchValue] = useState("");

  // Use debounced callback for search
  // const debouncedSearch = useDebouncedCallback(onSearch, 300);

  // const _handleSearchChange = (value: string) => {
  //   setSearchValue(value);
  //   debouncedSearch(value);
  // };

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center", width: "100%" }}>
      {/* <Box sx={{ minWidth: 150 }}>
        <AsyncSelect
          label=""
          placeholder="All Message Types"
          options={[
            { value: "", label: "All Message Types" },
            { value: "sent", label: "Sent" },
            { value: "received", label: "Received" },
            { value: "draft", label: "Draft" },
          ]}
          value={
            filters.messageType
              ? { value: filters.messageType, label: filters.messageType }
              : null
          }
          onChange={(option) => {
            onFilterChange("messageType", option?.value || "");
          }}
        />
      </Box>
      <TextField
        size="small"
        value={searchValue}
        onChange={(e) => handleSearchChange(e.target.value)}
        placeholder="Search by phone number, message"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, maxWidth: 300 }}
      /> */}
      {/* <StyledButtonV2
        variant="contained"
        shouldAddIcon={true}
        label="Send New SMS"
      /> */}
    </Box>
  );
};

export const ContactDictionaryFilters = ({
  filters,
  onFilterChange,
  onSearch,
  contactDictionaryDisclosure,
}: {
  filters: ContactDictionaryFilter;
  onFilterChange: (
    key: string,
    value: { value: string; label: string } | boolean
  ) => void;
  onSearch: (query: string) => void;
  contactDictionaryDisclosure: DisclosureHost;
}) => {
  const [searchValue, setSearchValue] = useState("");

  // Use debounced callback for search
  const debouncedSearch = useDebouncedCallback(onSearch, 300);

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    debouncedSearch(value);
  };

  return (
    <Flex justifyContent={"flex-end"} alignItems={"center"} gap={2}>
      <LabeledSwitch
        label="Show Archived Materials"
        checked={filters.archive}
        onChange={(e) => onFilterChange("archive", e.target.checked as any)}
      />
      <Box sx={{ minWidth: 220 }}>
        <AsyncSelect
          label=""
          placeholder="Select Contact Type"
          options={CONTACT_TYPE_OPTIONS}
          value={filters.contactType}
          onChange={(option) => {
            onFilterChange("contactType", option || { value: "", label: "" });
          }}
          // No search needed for static options
        />
      </Box>
      <SearchInput
        searchKey={searchValue}
        onSearch={handleSearchChange}
        placeholder="Search by name, email"
        sx={{ width: "18rem" }}
      />
      <StyledButtonV2
        variant="contained"
        shouldAddIcon={true}
        label="Add New Contact"
        onClick={() => contactDictionaryDisclosure?.open()}
        style={{ flexShrink: 0 }}
      />
    </Flex>
  );
};
